import { Checkbox } from "antd";
import { useState } from "react";
import { useSelector } from "react-redux";
import toast from "react-hot-toast";
import { IoCloseSharp } from "react-icons/io5";
import { Col, Modal, ModalBody, Row } from "reactstrap";
import { saveData, uniqueID } from "../../firebase/utility";
import GeneralButton from "../button/GeneralButton";
import FormInput from "../formInput/FormInput";
import { DEFAULT_PERMISSIONS } from "../../utils/permissions";
const AddNewUserModal = ({ modal, toggle }) => {
  const { user: currentUser } = useSelector((state) => state.auth);
  const [userData, setUserData] = useState({
    username: "",
    email: "",
    role: "",
    password: "",
    address: "",
    phone: "",
    hasManualQuotesAccess: false,
    autoWhitelistAllCustomers: false,
  });
  const [permissions, setPermissions] = useState([...DEFAULT_PERMISSIONS]);
  const handlePermissionChange = (e, index) => {
    let arr = [...permissions];
    arr[index].value = e.target.checked;
    setPermissions(arr);
  };
  const validateUser = () => {
    const { username, email, role, password, address, phone } = userData;
    if (!username || !email || !role || !password || !address || !phone) {
      toast.error("Please fill in all fields.");
      return false;
    }
    return true;
  };
  const handleUserCreate = () => {
    if (validateUser()) {
      let _id = uniqueID();
      let obj = { ...userData, _id, permissions };
      try {
        saveData("testUsers", _id, obj).then((res) => {
          if (res) {
            toast.success("User created Successfully");
            setUserData({
              username: "",
              email: "",
              role: "",
              password: "",
              address: "",
              phone: "",
              hasManualQuotesAccess: false,
              autoWhitelistAllCustomers: false,
            });
            toggle();
          }
        });
      } catch (error) {
        toggle();
      }
    }
  };
  return (
    <Modal isOpen={modal} toggle={toggle} centered size="lg">
      <ModalBody className="p-3 bg-light rounded">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h4 className="primary-color">Add New User</h4>
          <IoCloseSharp
            size={"30"}
            onClick={() => {
              toggle();
              setUserData(null);
            }}
          />
        </div>
        <Row className="mb-3">
          <Col md={6}>
            <FormInput
              type={"text"}
              label={"Username"}
              placeholder={"username..."}
              className={``}
              value={userData?.username}
              handleChange={(e) => {
                setUserData((userData) => ({
                  ...userData,
                  username: e.target.value,
                }));
              }}
              size={"medium"}
            />
          </Col>
          <Col md={6}>
            <FormInput
              type={"email"}
              label={"User Email"}
              placeholder={"email..."}
              size={"medium"}
              value={userData?.email}
              handleChange={(e) => {
                setUserData((userData) => ({
                  ...userData,
                  email: e.target.value,
                }));
              }}
            />
          </Col>
          <Col md={6}>
            <FormInput
              dropdown={true}
              label={"Role"}
              className={"bg-white border "}
              options={
                currentUser?.role === "Super-admin"
                  ? [
                    { label: "Supervisor", value: "Supervisor" },
                    { label: "Admin", value: "Admin" },
                  ]
                  : [
                    { label: "Supervisor", value: "Supervisor" },
                  ]
              }
              placeholder={"Select"}
              value={userData?.role}
              handleChange={(value) =>
                setUserData({
                  ...userData,
                  role: value,
                })
              }
              size={"medium"}
            />
          </Col>
          <Col md={6}>
            <FormInput
              type={"text"}
              label={"Address"}
              placeholder={"Address..."}
              size={"medium"}
              value={userData?.address}
              handleChange={(e) => {
                setUserData((userData) => ({
                  ...userData,
                  address: e.target.value,
                }));
              }}
            />
          </Col>
          <Col md={6}>
            <FormInput
              type={"number"}
              label={"phone"}
              placeholder={"phone..."}
              size={"medium"}
              value={userData?.phone}
              handleChange={(e) => {
                setUserData((userData) => ({
                  ...userData,
                  phone: e.target.value,
                }));
              }}
            />
          </Col>
          <Col md={6}>
            <FormInput
              type={"text"}
              label={"Password"}
              placeholder={"Password..."}
              size={"medium"}
              value={userData?.password}
              handleChange={(e) => {
                setUserData((userData) => ({
                  ...userData,
                  password: e.target.value,
                }));
              }}
            />
          </Col>
          <div className="mt-2 w-100 px-3">
            <h6 className="fw-semibold mb-2">Additional Options</h6>
            <Row className="g-2 w-100 m-0">
              <Col md={6}>
                <div className="border rounded p-2 d-flex align-items-center bg-white shadow-sm border-primary h-100">
                  <Checkbox
                    checked={userData?.hasManualQuotesAccess}
                    onChange={(e) =>
                      setUserData((userData) => ({
                        ...userData,
                        hasManualQuotesAccess: e.target.checked,
                      }))
                    }
                  >
                    <span className="fw-semibold">Has Manual Quotes Access</span>
                  </Checkbox>
                </div>
              </Col>
              <Col md={6}>
                <div className="border rounded p-2 d-flex align-items-center bg-white shadow-sm border-primary h-100">
                  <Checkbox
                    checked={userData?.autoWhitelistAllCustomers}
                    onChange={(e) =>
                      setUserData((userData) => ({
                        ...userData,
                        autoWhitelistAllCustomers: e.target.checked,
                      }))
                    }
                  >
                    <span className="fw-semibold">Auto Whitelist All Customers</span>
                  </Checkbox>
                </div>
              </Col>
            </Row>
          </div>
          {(currentUser?.role === "Super-admin" || (currentUser?.role === "Admin" && userData?.role === "Supervisor")) && (
            <div className="mt-3 w-100 px-3">
              <h6 className="fw-semibold mb-2">Permissions</h6>
              <Row className="g-2 w-100 m-0">
                {permissions?.map((i, index) => {
                  return (
                    <Col md={6} key={index}>
                      <div className="border rounded p-2 d-flex align-items-center bg-light">
                        <Checkbox
                          checked={i?.value}
                          onChange={(e) => handlePermissionChange(e, index)}
                        >
                          {i?.name}
                        </Checkbox>
                      </div>
                    </Col>
                  );
                })}
              </Row>
            </div>
          )}
          <div className="d-flex justify-content-end">
            <GeneralButton
              title={"Cancel"}
              className={"white-button mx-2"}
              width={"180px"}
              handleClick={() => {
                toggle();
              }}
            />
            <GeneralButton
              title={"Save"}
              className={"blue-button"}
              width={"180px"}
              handleClick={() => {
                handleUserCreate();
              }}
            />
          </div>
        </Row>
      </ModalBody>
    </Modal>
  );
};
export default AddNewUserModal;
